import { MediaPickerDialogConfig, MediaPickerDialogItem, MediaPickerDialogTask } from 'components/mediaPickerDialog/mediaPickerDialog';
import { WCCVideoRecorderConfig } from 'components/videoRecorder/videoRecorder';
import { wccModules } from 'enums/wccModules';
import { FilesHelpers } from 'helpers/files';
import { RecordingHelpers } from 'helpers/recording';
import { BlobWrapper } from 'interfaces/blobWrapper';
import { inject, injectable } from 'inversify';
import overlayManager from 'managers/overlay';
import WCCS3VideoUploader from 'managers/uploads/s3/video';
import WCCVideo from 'models/attachments/video';
import './wccVideoPicker.html';
import './wccVideoPicker.scss';

components.preload('wcc-video-recorder', 'media-picker-dialog');

export interface WCCVideoPickerVMConfig {
    key?: string,

    onUploaded?: Action<[WCCVideo | undefined]>
}

@injectable()
export default class WCCVideoPickerVM {
    private videoUploader: WCCS3VideoUploader;

    private onUploadedCallback: Action<[WCCVideo | undefined]>

    mediaPickerConfig: MediaPickerDialogConfig

    constructor(
        @inject(wccModules.componentConfig) config: WCCVideoPickerVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.onUploadedCallback = config.onUploaded ?? _.noop;

        this.videoUploader = new WCCS3VideoUploader({ key: config.key });
        const upload = this.videoUploader.uploads.first();
        const uploadTask = upload.pluck(u => (<MediaPickerDialogTask>{ title: labels.Uploading, progress: u.progress }));

        const isReady = ko.observable(false);
        const isRecordingSupported = ko.observable(true);

        const items = ko.pureComputed(() => {
            if (isReady()) {
                const items = <Array<MediaPickerDialogItem>>[];

                items.push({
                    title: labels.UploadVideo,
                    icon: 'fas fa-cloud-upload',
                    onClick: () => this.pickVideo()
                });

                if (isRecordingSupported()) {
                    items.push({
                        title: labels.RecordVideo,
                        icon: 'fas fa-webcam',
                        onClick: () => this.recordVideo()
                    });
                }

                return items;
            }
        });        

        this.mediaPickerConfig = {
            items: items,
            task: uploadTask,
            ready: isReady
        }

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-video-picker': true
            }
        });

        RecordingHelpers.checkIfVideoRecordingIsSupported().then(value => {
            isRecordingSupported(value);
            isReady(true);
        });
    }

    private async pickVideo() {
        const video = await this.videoUploader.upload(await FilesHelpers.pickFile(true, 'video/*'));
        this.onUploadedCallback(video);
    }

    private async recordVideo() {
        const blob = await new Promise<BlobWrapper | undefined>(resolve => {
            overlayManager.toOverlay(`<wcc-video-recorder params="model: $data"/>`, {
                lock: true,
                buttons: ['close'],

                data: stage => {
                    return <WCCVideoRecorderConfig>{
                        fitViewport: true,

                        onRecorded: blob => {
                            resolve(blob);
                            stage.close();
                        }
                    }
                },

                onClose: () => resolve(undefined)
            });
        });

        if (blob != undefined) {
            const video = await this.videoUploader.upload(blob);
            this.onUploadedCallback(video);
        } else {
            this.onUploadedCallback(undefined);
        }
    }
}